'use client';
import React from 'react';
import { ProductAccordion as SharedProductAccordion } from '@launchstore/shared-puck';
import type { ProductAccordionProps } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import type { ProductData } from '@launchstore/shared-puck';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return {
    id: p.id, title: p.title, description: p.description, handle: p.handle,
    material: p.material, weight: p.weight, length: p.length, width: p.width, height: p.height,
    origin_country: p.origin_country, metadata: p.metadata,
    collection: p.collection ? { title: p.collection.title, handle: p.collection.handle } : null,
    categories: (p.categories || []).map((c: any) => ({ name: c.name, handle: c.handle })),
    variants: (p.variants || []).map((v: any) => ({
      id: v.id, sku: v.sku, weight: v.weight, length: v.length, width: v.width, height: v.height,
    })),
  };
};

const SharedProductAccordionRender = (SharedProductAccordion as any).render;

const ProductAccordionImpl: React.FC<ProductAccordionProps> = (props: any) => {
  const { product } = useProduct();
  return <SharedProductAccordionRender {...(props as any)} product={toProductData(product)} />;
};

export const ProductAccordion: any = { ...SharedProductAccordion, render: (props: any) => <ProductAccordionImpl {...props} /> };
export default ProductAccordion;
